import * as backofficeApi from '../../../services/api/backofficeApi';
import * as skinActions from '../../skinActions';
import * as templateService from '../../../services/template/templateService';
import * as skinUtils from '../../../utils/skinUtils';
import { getLogger } from '../../../services/logger';

const debug = getLogger('actions:skinActions');

export let loadAndApplySkin = customerId => {
  return async dispatch => {
    return backofficeApi
      .getSkinUrlTemplate(customerId)
      .then(response => {
        let skinUrl = response.data;
        dispatch(skinActions.setSkinUrl(skinUrl));
        return templateService.loadAndMergeTemplate(skinUrl).then(skin => {
          return dispatch(skinActions.applySkin(skin, customerId));
        });
      })
      .catch(error => {
        debug.error('[loadAndApplyThemeSetting] Error loading template %s', error);
        dispatch(skinActions.applySkin(skinUtils.getLastOrDefaultSkin()));
      });
  };
};
